import {TemplateHomeEvents} from "./TemplateHomeEvents";

export const PluginEvents = {
	init(): void {
		TemplateHomeEvents( document.documentElement );
	}
}
